<template>
  <div class="part-item projectBuilding">
    <p class="part-title">知识产权
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem()"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openIntel"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <span class="content-title">软件名称：</span>
      <div
        class="content-text"
        v-if="!formInfo.intellectual_name"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_name"
        v-html="formInfo.intellectual_name"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">是否与课程名称一致：</span>
      <div
        class="content-text"
        v-if="formInfo.intellectual_same !== '0' && formInfo.intellectual_same !== '1'"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_same === '0' || formInfo.intellectual_same === '1'"
      >
        {{ formInfo.intellectual_same === '1' ? '是' : '否' }}
      </div>
      <div class="clearfix"></div>
      <span class="content-title">著作权人：</span>
      <div
        class="content-text"
        v-if="!formInfo.intellectual_username"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_username"
      >
        <table class="tablePower">
          <tr
            v-for="(item, index) in formInfo.personData"
            :key="index"
          >
            <td>（{{ index + 1 }}）{{ item.name }}</td>
            <td>{{ dictPowerType[item.type] }}</td>
          </tr>
        </table>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">权利范围：</span>
      <div
        class="content-text"
        v-if="!formInfo.intellectual_power"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_power"
        v-html="formInfo.intellectual_power"
      ></div>
      <div class="clearfix"></div>
      <span class="content-title">软件著作登记号：</span>
      <div
        class="content-text"
        v-if="!formInfo.intellectual_no"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_no"
        v-html="formInfo.intellectual_no"
      ></div>
      <div class="clearfix"></div>
      <div style="color: #aaa; margin-bottom: 5px;">如软件著作权正在申请过程中，尚未获得证书，请填写受理流水号。</div>
      <div class="clearfix"></div>
      <span class="content-title">受理流水号：</span>
      <div
        class="content-text"
        v-if="!formInfo.intellectual_serial_number"
      >暂无内容</div>
      <div
        class="content-text"
        v-if="formInfo.intellectual_serial_number"
        v-html="formInfo.intellectual_serial_number"
      ></div>
    </div>

    <div
      class="form_overlay"
      id="building_overlay"
      :style="formatShowWindow(showWindow.intel)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style="width:600px"
      >
        <div class="form_title">知识产权</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.intel = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div class="form_content">
          <form id="buildingForm">
            <div class="item">
              <span class="label"><i class="require"></i>软件名称</span>
              <input
                type="text"
                v-model="formIntel.intellectual_name"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>是否与项目名称一致</span>
              <select v-model="formIntel.intellectual_same">
                <option value="">请选择</option>
                <option value="1">是</option>
                <option value="0">否</option>
              </select>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>著作权人</span>
              <div class="div_person">
                <div
                  v-for="(item, index) in showWindow.personData"
                  :key="index"
                  class="div_person_row"
                >
                  <input
                    type="text"
                    v-model="item.name"
                    maxlength="25"
                  >
                  <select v-model="item.type">
                    <option value="">请选择著作权类型</option>
                    <option
                      v-for="(v, k, index) in dictPowerType"
                      :value="k"
                      :key="index"
                    >{{ v }}</option>
                  </select>
                  <input
                    type="button"
                    value="X"
                    @click="showWindow.personData.splice(index, 1)"
                  >
                </div>
                <div>
                  <input
                    type="button"
                    value="+"
                    @click="showWindow.personData.push({ name: '', type: '' })"
                    class="div_person_add"
                  >
                </div>
              </div>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>权力范围</span>
              <input
                type="text"
                v-model="formIntel.intellectual_power"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>登记号</span>
              <input
                type="text"
                v-model="formIntel.intellectual_no"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>受理流水号</span>
              <input
                type="text"
                v-model="formIntel.intellectual_serial_number"
                maxlength="25"
              >
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.intel = false"
            class="button close"
            id="building_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveIntel"
            class="button"
            id="building_submit"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExperimentMaintainIntel',
  props: ['isShow', 'expId'],
  data () {
    return {
      formInfo: {
        personData: []
      },
      showWindow: {
        intel: false,
        personData: []
      },
      formIntel: {
        intellectual_name: '',
        intellectual_same: '',
        intellectual_username: '',
        intellectual_power: '',
        intellectual_no: '',
        intellectual_serial_number: ''
      },
      dictPowerType: {
        1: '课程所属学校',
        2: '企业',
        3: '课程负责人',
        4: '学校团队成员',
        5: '企业人员',
        6: '其他'
      }
    }
  },
  methods: {
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.personData = data.intellectual_username ? JSON.parse(data.intellectual_username) : []
      }).catch((error) => {
        console.log(error)
      })
    },
    openIntel() {
      this.formIntel.intellectual_name = this.formInfo.intellectual_name
      this.formIntel.intellectual_same = this.formInfo.intellectual_same
      this.formIntel.intellectual_username = this.formInfo.intellectual_username
      this.formIntel.intellectual_power = this.formInfo.intellectual_power
      this.formIntel.intellectual_no = this.formInfo.intellectual_no
      this.formIntel.intellectual_serial_number = this.formInfo.intellectual_serial_number
      this.showWindow.personData = this.formInfo.intellectual_username ? JSON.parse(this.formInfo.intellectual_username) : []
      this.showWindow.intel = true
    },
    async saveIntel(category = 0) {
      const url = '/experiment/' + this.expId + '/'
      if (category === 1) {
        this.formIntel.intellectual_username = ''
      } else {
        this.formIntel.intellectual_username = JSON.stringify(this.showWindow.personData)
      }
      await this.$http.put(url, this.formIntel).then((data) => {
        if (data.id) {
          this.formInfo.intellectual_name = this.formIntel.intellectual_name
          this.formInfo.intellectual_same = this.formIntel.intellectual_same
          this.formInfo.intellectual_username = this.formIntel.intellectual_username
          this.formInfo.intellectual_power = this.formIntel.intellectual_power
          this.formInfo.intellectual_no = this.formIntel.intellectual_no
          this.formInfo.intellectual_serial_number = this.formIntel.intellectual_serial_number
          this.formInfo.personData = this.formIntel.intellectual_username ? JSON.parse(this.formIntel.intellectual_username) : []
          this.showWindow.intel = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    clearItem() {
      this.formIntel = {
        intellectual_name: '',
        intellectual_same: '',
        intellectual_username: '',
        intellectual_power: '',
        intellectual_no: '',
        intellectual_serial_number: ''
      }
      this.saveIntel(1)
    }
  },
  async mounted() {
    await this.getInfo()
  }
}
</script>

<style scoped src="../../../../assets/css/project-detail.css"></style>
<style scoped src="../../../../assets/css/table.css"></style>
<style scoped src="../../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
.tablePower {
  border: 0px;
  tr > td:nth-child(2) {
    padding-left: 50px;
  }
}

.div_person {
  margin-left: 150px;

  .div_person_row {
    margin-bottom: 5px;

    input {
      width: 80px;
      margin-top: -2px;
    }

    select {
      width: 80px;
    }
    input[type="button"] {
      width: 32px;
      height: 32px;
      background-color: #ccc;
      color: orangered;
      border: 0px;
      margin-top: -2px;
    }
  }
  .div_person_add {
    width: 64px;
    height: 32px;
    background-color: orange;
    color: white;
    border: 0px;
  }
}

.content .container {
  width: 1200px;
  margin: 0 auto;
  visibility: visible;
}

.center_content {
  .box-wrap {
    margin-top: 20px;
    padding: 40px;
    background: #fff;
    box-sizing: border-box;
  }

  .title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-right: 160px;
    padding-left: 20px;

    .title-btns {
      position: absolute;
      top: 0;
      right: 0;

      > a {
        margin-right: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: #3399ff;
        cursor: pointer;

        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .title:before {
    content: "";
    width: 4px;
    height: 1em;
    background-color: #73D6CA;
    position: absolute;
    left: 0;
    top: 16px;
  }

  .mbox .lBox {
    float: left;
    width: 600px;

    .detail-base {
      font-size: 16px;
      padding: 20px 0;
      height: 376px;
      box-sizing: border-box;
      overflow-y: auto;

      .detail-item {
        display: inline-block;
        margin-right: 30px;
        padding: 10px 0;
      }

      .detail-intro {
        padding: 10px 0;

        .label {
          float: left;
        }

        p {
          padding-left: 80px;
        }
      }

      .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        overflow: hidden;
      }
    }
  }

  .label {
    width: 130px;
    padding-right: 10px;
  }

  .mbox .rBox {
    float: right;
    width: 460px;

    .preview {
      padding: 6px 20px;
      border: 1px solid #73D6CA;
      color: #73D6CA;
      border-radius: 3px;
    }

    .submit {
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
    }

    .imgCover {
      width: 100%;
      height: 306px;
      margin-top: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .upload {
      width: 140px;
      height: 40px;
      line-height: 40px;
      display: block;
      margin: 10px auto;
      text-align: center;
      background: #21b295;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .part-content {
    .part-new-table {
      margin: 10px 0;
      border: 1px solid #ebebeb;
      width: 100%;
      max-width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      background-color: transparent;
      tr th {
        background-color: #f8faff;
        color: #999;
        font-weight: normal;
      }
    }
    .part-new-table tr th,
    .part-new-table tr td {
      padding: 8px;
      line-height: 1.42857143;
      vertical-align: middle;
      border: 1px solid #ebebeb;
      text-align: center;
    }
  }
  .item-box {
    float: left;
    width: 302px;
    position: relative;
  }

  .uploadImgPreview li img {
    width: 100%;
    margin-top: 5px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
  }

  .video-box {
    .lBox {
      float: left;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }

    .video-wrap {
      width: 400px;
      height: 226px;
      margin: 10px auto 0;
      background: #000;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .rBox {
      float: right;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }
  }

  .menu-box {
    overflow: hidden;
    border-bottom: 1px solid #eee;

    ul {
      li {
        text-align: center;
        float: left;
        margin-right: 10px;

        a {
          display: block;
          padding: 10px;
          font-size: 16px;
          color: #002900;
          text-decoration: none;
          border-bottom: 3px solid #fff;
        }

        &:hover a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }

      .onActive {
        a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }
    }
  }

  .part {
    min-height: 390px;
    margin-top: 30px;
  }
}
.form_contentEdit .label {
  width: 100px !important;
}
.form_content .k-container {
  max-width: 640px;
  width: 640px;
  .item-table {
    width: 640px;
    input {
      width: 100%;
      border: none;
    }
  }
  .item-table th,
  .item-table td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    padding-bottom: 1px;
  }
}
.teachItem {
  p {
    font-weight: 600;
  }
  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}
.teachEdit {
  .m-r {
    color: #333333;
    font-weight: 500;
    display: inline-block;
    width: 150px;
    input {
      position: relative;
      top: -1px;
      margin-right: 7px;
    }
  }
  .file {
    color: #0b80ff;
    display: block;
    .del {
      margin-left: 10px;
      font-size: 22px;
      color: #c7254e;
      cursor: pointer;
      margin: 0;
      background: transparent;
      top: 3px;
      position: relative;
    }
  }
  .upload {
    display: block;
    text-align: center;
    width: 55px;
    line-height: 30px;
    background: #f19830;
    color: #fff;
    cursor: pointer;
  }
}
.warn {
  p {
    font-size: 12px;
    color: #df3d3e;
  }
  span {
    font-size: 12px;
    color: #337ab7;
    cursor: pointer;
  }
}
.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}
.teach_Item {
  color: #666;
  .text {
    width: 40px !important;
    height: 20px !important ;
    line-height: 23px !important;
    border: none !important;
    text-align: center;
    border-bottom: 1px solid #999 !important;
  }
}
.form_overlay {
  z-index: 100 !important;
}

.file-upload {
  z-index: 200 !important;
}

.menu-list > li.on a,
.menu-list > li:hover a {
  color: #73D6CA !important;
  border-color: #73D6CA !important;
}
.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}
.del-icon {
  color: #ff0000;
  position: relative;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  right: 17px;
  top: -12px;
  cursor: pointer;
}
.url_link {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
}
.url_link::-webkit-scrollbar {
  display: none;
}
.form_control {
  text-align: center;
}
.form_control a {
  float: none;
  display: inline-block;
}
.addOtherUser {
  display: inline-block;
  color: #ffffff;
  margin-left: 15px;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 4px;
  background-color: #028c8c;
  border-color: #028c8c;
  cursor: pointer;
}
.infor span {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
  display: inline-block;
  margin-bottom: 10px;
  display: inline-block;
}
.infor span i {
  color: #999;
}
.person {
  position: relative;
  overflow: hidden;
}
.person_symbol {
  position: absolute;
  left: -20px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg); /* Internet Explorer 9*/
  -moz-transform: rotate(-45deg); /* Firefox */
  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
  -o-transform: rotate(-45deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}
.tips {
  margin-bottom: 10px;
  color: rgb(144, 144, 144);
}
.content_underline {
  text-decoration: underline;
  margin: 0 10px;
}
</style>
